<template>
  <div class='newplace'>
    <img src="/static/images/activty/newplace/appnewplace_01.jpg">
    <img src="/static/images/activty/newplace/appnewplace_02.jpg">
    <img src="/static/images/activty/newplace/appnewplace_03.jpg">
    <img src="/static/images/activty/newplace/appnewplace_04.jpg">
    <img src="/static/images/activty/newplace/appnewplace_05.jpg">
    <img src="/static/images/activty/newplace/appnewplace_06.jpg">
    <img src="/static/images/activty/newplace/appnewplace_07.jpg">
  </div>
</template>
<script>
export default {
  name: '',
  components: {},
  data() {
    return {
    }
  },
  watch: {
  },
  mounted() {},
  created() {
  },
  methods: {
    
  },
}

</script>
<style scoped>
.newplace{
  width: 100%;
}
.newplace img{
  width: 100%;
  display: block;
  overflow: hidden;
}

</style>



// WEBPACK FOOTER //
// src/components/activity/appnewplace.vue